import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';

@Component({
  selector: 'app-modal-add-code',
  templateUrl: './modal-add-code.component.html',
  styleUrls: ['./modal-add-code.component.css']
})
export class ModalAddCodeComponent {
  codeForm: FormGroup;
  @Output() OnGuardarClicked: EventEmitter<any> = new EventEmitter();

  modalTitle: string = '';
  edit: any = 0;
  loading: any;

  serial: string | null = null;
  description: string | null = null;
  foreign: string | null = null;
  un: string | null = null;
  un_est: string | null = null;
  un_for: string | null = null;
  factor: string | null = null;
  sku_management: string | null = null;

  constructor(
    private fb: FormBuilder,
    public modalRef: MdbModalRef<ModalAddCodeComponent>
  ) {
    this.codeForm = this.fb.group({
      serial: ['', [Validators.required, Validators.minLength(5)]],
      description: ['', [Validators.required, Validators.minLength(5)]],
      foreign: ['', [Validators.required]],
      un: ['', [Validators.required]],
      un_est: ['', [Validators.required]],
      un_for: ['', [Validators.required]],
      factor: ['', [Validators.required]],
      sku_management: ['', [Validators.required]],
    });
  }

  ngOnInit() {
    this.codeForm.patchValue({
      serial: this.serial,
      description: this.description,
      foreign: this.foreign,
      un: this.un,
      un_est: this.un_est,
      un_for: this.un_for,
      factor: this.factor,
      sku_management: this.sku_management,
    });
  }

  InsertOrUpdate() {
    const body = new FormData();
    body.append('serial', this.codeForm.value.serial);
    body.append('description', this.codeForm.value.description);
    body.append('foreign', this.codeForm.value.foreign);
    body.append('un', this.codeForm.value.un);
    body.append('un_est', this.codeForm.value.un_est);
    body.append('un_for', this.codeForm.value.un_for);
    body.append('factor', this.codeForm.value.factor);
    body.append('sku_management', this.codeForm.value.sku_management);
    body.append('id_company', localStorage.getItem('IdCompany') ?? '');

    const codeRegister = {
      serial: this.codeForm.value.serial,
      description: this.codeForm.value.description,
      foreign: this.codeForm.value.foreign,
      un: this.codeForm.value.un,
      un_est: this.codeForm.value.un_est,
      un_for: this.codeForm.value.un_for,
      factor: this.codeForm.value.factor,
      sku_management: this.codeForm.value.sku_management,
      id_company: localStorage.getItem('IdCompany'),
      is_approved: 1,
      reason: '',
    }
    this.modalRef.close(codeRegister);
  }
}
